module.exports = __webpack_public_path__ + "static/img/lumbarPainMan_0.55cb2765.png";